import {
    RefreshCw,
    Download,
    Plus,
} from "lucide-react";

function RoleHeader({
    reload,
    onAddRole,
}) {

    return (

        <div className="roles-header">

            <div>

                <h1>Roles & Permissions</h1>

                <p>
                    Manage admin roles and access permissions.
                </p>

            </div>

            <div className="roles-actions">

                <button
                    className="refresh-btn"
                    onClick={reload}
                >

                    <RefreshCw size={18} />

                    Refresh

                </button>

                <button
                    className="export-btn"
                >

                    <Download size={18} />

                    Export

                </button>

                <button
                    className="add-btn"
                    onClick={onAddRole}
                >

                    <Plus size={18} />

                    Add Role

                </button>

            </div>

        </div>

    );

}

export default RoleHeader;